import { create } from 'zustand';
import { parseMapsApp, type MapsApp } from '../lib/directions';

export const MAPS_PREF_STORAGE_KEY = 'blast-crm-maps-app';

interface MapsPrefState {
  mapsApp: MapsApp;
  setMapsApp: (app: MapsApp) => void;
  initMapsApp: () => void;
}

function readStored(): MapsApp {
  return parseMapsApp(localStorage.getItem(MAPS_PREF_STORAGE_KEY));
}

export const useMapsPrefStore = create<MapsPrefState>((set) => ({
  mapsApp: readStored(),

  setMapsApp: (app: MapsApp) => {
    localStorage.setItem(MAPS_PREF_STORAGE_KEY, app);
    set({ mapsApp: app });
  },

  initMapsApp: () => set({ mapsApp: readStored() }),
}));
